import { z } from 'zod';

export enum FORM_ERROR_MESSAGES {
  EMAIL_REQUIRED = 'Email is required.',
  EMAIL_EXCEEDED = 'Email has exceeded character limit.',
  EMAIL_INVALID = 'Invalid Email.',
}

export const getUpdatesUnsubscribeSchema = z.object({
  emailAddr: z
    .string()
    .min(1, { message: FORM_ERROR_MESSAGES.EMAIL_REQUIRED })
    .max(120, FORM_ERROR_MESSAGES.EMAIL_EXCEEDED)
    .email(FORM_ERROR_MESSAGES.EMAIL_INVALID),
});

export type GetReleaseUpdatesUnsubscribeForm = z.infer<
  typeof getUpdatesUnsubscribeSchema
>;
